import React, { useState, useEffect, useMemo } from 'react';
import { Modal, ModalBody, ModalHeader, Input, FormGroup, Button, Label, Form } from 'reactstrap';
import { useNavigate,useLocation } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import moment from 'moment';
import $ from 'jquery';
import { parseValue } from '../utils/Common';
import Table from './common/Table';

const common = require('../utils/Common');
const envConfig = require('../config/envConfig');


export default function SellersBuyersOrders() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [deliveryUsers, setDeliveryUsers] = useState([]);
    const [orderStatuses, setOrderStatuses] = useState([]);
    const [orderImagesData, setOrderImagesData] = useState([]);
    const [showOrderImagesModal, setShowOrderImagesModal] = useState(false);
    const [orderTrackingData, setOrderTrackingData] = useState([]);
    const [orderTrackings, setOrderTrackings] = useState(false);
    const location = useLocation();
    const [totalRecords, setTotalRecords] = useState(0);

    const [showLogisticsVendor, setShowLogisticsVendor] = useState({
        show: false,
        orderItemId: 0,
        orderId: 0,
        type: null,
        sellerAddressId: 0,
        sellerId: 0,
        self_deliver: 0,
        order_status: null
    });
    const [supplyVendors, setSupplyVendors] = useState({
        vendors: [],
        productItemData: [],
        thirdPartyVendors: []
    });

    useEffect(() => {
        getOrders();
        getDeliveryUsers();
    }, []);

    const showOrderTrackings = async (orderItemId = 0) => {
        if (orderItemId) {
            let data = {
                'order_item_id': orderItemId
            }
            let response = await common.apiRequest('post', '/orders/get-order-trackings', data);
            setOrderTrackingData(response?.data || []);
            setOrderTrackings(!orderTrackings);
        } else {
            setOrderTrackings(!orderTrackings);
            setOrderTrackingData([]);
        }
    }

    const getOrders = async (limit = 10, offset = 0, search = {}) => {
        let data = {
            'seller_id' : location.state.sellerId,
            'start_date':  location.state.startDate.length > 0 ? location.state.startDate : $('#Date-from').val(),
            'end_date': location.state.endDate.length > 0 ? location.state.endDate : $('#Date-to').val(),
            'source': 'admin',
            'limit': limit,
            'offset': offset
        }
        let response = await common.apiRequest('post', '/seller/get-orders', data);
        if (response.data.code === 'success') {
            setOrders(response.data.data);
            setTotalRecords(response.data.totalRecords);
        } else {
            setOrders([]);
        }
    }

    const getDeliveryUsers = async () => {
        let data = {
            'action': 'read',
            'deliver_manager_id': location.state
        }
        let response = await common.apiRequest('post', '/delivery/crud-delivery-users', data);
        if (response.data.code === 'success') {
            setDeliveryUsers(response.data.data);
        } else {
            setDeliveryUsers([]);
        }
    }


    const generateInvoice = async (sellerId, orderId, invoiceType) => {
        let response = await common.getInvoiceData([sellerId], orderId, invoiceType);
        if (response.length === 0) {
            alert('No invoice');
            return;
        }
        navigate(
            '/generate-invoice',
            {
                state: {
                    invoiceData: response
                }
            }
        )
    }

    const generateCommissionInvoice = async (orderId) => {
        let response = await common.getCommissionInvoice(orderId, 'order');
        if (response.length === 0) {
            common.alert('No invoice', 'error');
            return;
        }
        navigate(
            '/generate-commission-invoice',
            {
                state: {
                    invoiceData: response
                }
            }
        );
    }

    const generateReturnReplaceCancelInvoice = async (orderId, sellerIds, type, invoiceType) => {
        let response = await common.getInvoiceData(sellerIds, orderId, type, 1);
        navigate(
            '/generate-return-invoice',
            {
                state: {
                    invoiceData: response,
                    invoiceType: invoiceType
                }
            }
        )
    }


    const showOrderImages = async (orderItemId) => {
        let response = await common.fetchOrderImages(orderItemId);
        if (response && response.data && response.data.data && response.data.data.length > 0) {
            setOrderImagesData(response.data.data);
            setShowOrderImagesModal(true);
        } else {
            setOrderImagesData([]);
            setShowOrderImagesModal(false);
            alert("No Order Images Found", "info");
        }
    }

    const downloadManifestOrLabel = (labelUrlOrAwb, viaAPI = false, orderItemId = 0, columnName = null) => {
        if (!labelUrlOrAwb) {
            alert("Something went wrong", "error");
            return;
        }
        if (!viaAPI) {
            const link = document.createElement('a');
            link.href = labelUrlOrAwb;
            link.target = '_blank';
            link.download = labelUrlOrAwb.split('/').pop();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            if (labelUrlOrAwb) {
                let data = {
                    awb: labelUrlOrAwb,
                    id: orderItemId,
                    columnName: columnName
                }
                common.apiRequest('post', '/orders/download-ecom-label', data)
                .then(response => {
                    const link = document.createElement('a');
                    link.href = envConfig.api_url + response.data.url;
                    link.target = '_blank';
                    link.download = labelUrlOrAwb+'.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    console.error('Error downloading label:', error);
                    alert('Error downloading label: ' + error.message, "error");
                });
            } else {
                alert('AWB is not available.', "error");
            }
        }
    };


    const updateReturnReplaceLogisticsVendor = async (updateDb, data, type) => {
        if (updateDb) {
            let price = 0, isThirdParty = 0, thirdPartyName = null, thirdPartyData = null;
            if (type == -2) {
                price = Number(data.total_price);
                isThirdParty = 1;
                thirdPartyName = 'ecomexpress';
                thirdPartyData = data.data[0]['vendors']
            } else if (type != -1) {
                price = Number(data.total_price[type]);
                isThirdParty = 1;
                thirdPartyName = 'shiprocket';
                thirdPartyData = data.data[0]['vendors'][type];
            } else {
                price = data?.seller_service?.price;
            }
            let params = {
                "order_item_id": showLogisticsVendor.orderItemId,
                "order_id": showLogisticsVendor.orderId,
                "type": showLogisticsVendor.type,
                "is_third_party_logistics": isThirdParty,
                "third_party_logistics_name": thirdPartyName,
                "third_party_logistics_data": thirdPartyData,
                "seller_address_id": showLogisticsVendor.sellerAddressId,
                "seller_id": showLogisticsVendor.sellerId,
                "self_deliver": showLogisticsVendor.self_deliver,
                "order_status": showLogisticsVendor.order_status,
                "logistic_order": {
                    "type": showLogisticsVendor.type,
                    "order_item_id": showLogisticsVendor.orderItemId,
                    "seller_id": data?.seller_service?.seller_id || 0,
                    "service_id": data?.seller_service?.id || 0,
                    "order_price": price,
                    "zone": supplyVendors.productItemData[0]['zone'],
                    "distance": supplyVendors.productItemData[0]['distance'],
                    "tax_type": supplyVendors.productItemData[0]['type'],
                    "order_id": showLogisticsVendor.orderId
                },
                "order_item": {
                    [showLogisticsVendor.type + "_logistics_vendor"]: data?.seller_service?.seller_id || 0
                }
            }
            setShowLogisticsVendor({
                show: false,
                orderItemId: 0,
                orderId: 0,
                type: null,
                sellerAddressId: 0,
                sellerId: 0,
                self_deliver: 0,
                order_status: null
            });
            setSupplyVendors({
                vendors: [],
                productItemData: []
            });
            let response = await common.apiRequest('post', '/orders/update-return-replace-logistics-vendors', params);
            if (response.data.code === 'success') {
                alert(response.data.message);
            } else {
                alert(response.data.error);
            }
            getOrders();
        } else {
            let userAddressId = data.order.address_id;
            let params = {
                'seller_id': Number(data.seller_id),
                'order_item_id': Number(data.id),
                'order_id': Number(data.order.id),
                'user_address_id': userAddressId,
                'product_item_data': [],
                "logistics_delivery_type": ["Normal Delivery", "Express Delivery"],
                "is_return": type == "return" ? 1 : 0,
                "is_replace": type == "replace" ? 1: 0,
                "declared_value": 0,
                "self_deliver": data.product_item.self_deliver,
                "seller_address_id": data.product_item.product.seller_address_gst
            }
            let response = await common.apiRequest('post', '/products/check-product-delivery-vendors', params);
            if (response.data.code === 'success') {
                setShowLogisticsVendor({
                    show: true,
                    orderItemId: data?.id,
                    orderId: data.order?.id,
                    type: type,
                    sellerAddressId: Number(data.product_item.product.seller_address_gst),
                    sellerId: Number(data.seller_id),
                    self_deliver: Number(data.product_item.self_deliver),
                    order_status: data.order_status
                });
                setSupplyVendors({
                    vendors: response.data.data.vendors,
                    productItemData: response.data.data.product_item_data,
                    thirdPartyVendors: response.data.data.third_party_vendors
                });
            } else {
                setShowLogisticsVendor({
                    show: false,
                    orderItemId: 0,
                    orderId: 0,
                    type: null,
                    sellerAddressId: 0,
                    sellerId: 0,
                    self_deliver: 0,
                    order_status: null
                });
                setSupplyVendors({
                    vendors: [],
                    productItemData: []
                });
                alert(response.data.error);
            }
        }
    }

    const data = orders.map(data => ({
        orderId: data.order?.order_id || "NA",
        orderType: data.product_item 
            ? "Online Product Sale" 
            : data.seller_service 
                ? "Online Service Sale" 
                : "Offline Product Sale",
        sellerLogisticsBothOrder: (() => {
            const isLogistics = data.logistics_vendor_id == location.state;
            const isSeller = data.seller_id == location.state;
            const isOfflineSale = data.offline_sale_product_datum?.offline_sale?.seller_id == location.state; 
            if ((isLogistics && isSeller) || isOfflineSale) return "Both";
            if (isLogistics) return "Logistics";
            return "Seller";
        })(),
        "Product Name": data.product_item 
            ? data.product_item.product.name 
            : data.seller_service 
                ? data.seller_service.service_name 
                : data.offline_sale_product_datum?.product_description || "NA",
        "product Description": data.product_item 
            ? data.product_item.product.description 
            : data.seller_service 
                ? data.seller_service.service_description 
                : data.offline_sale_product_datum?.product_description || "NA",
        "User InvoiceNo": data.order?.invoices?.find(inv => inv.invoice_type === 'product')?.invoice_no || "NA",
        "seller InvoiceNo": data.order?.invoices?.find(inv => 
            inv.invoice_type === 'seller_product')?.invoice_no || "NA",
            "Logistics Seller InvoiceNo": (() => {
                if (data.logistics_order?.all_logistics_invoice?.length > 0) {
                    const logisticInvoice = data.logistics_order.all_logistics_invoice.find(
                        inv => inv.invoice_type === 'logistics'
                    );
                    return logisticInvoice ? logisticInvoice.invoice_no : "NA";
                }
                return "NA";
            })(),
            
            "Logistics Price": (() => {
                if (data.logistics_order?.all_logistics_invoice?.length > 0) {
                    const logisticInvoice = data.logistics_order.all_logistics_invoice.find(
                        inv => inv.invoice_type === 'logistics'
                    );
                    
                    if (logisticInvoice && logisticInvoice.price) {
                        const itemCount = data.logistics_order.order_item_id ? 
                            data.logistics_order.order_item_id.split(',').length : 1;
                        
                        const pricePerItem = parseFloat(logisticInvoice.price) / itemCount;
                        
                        return pricePerItem.toFixed(2);
                    }
                }
                return 0;
            })(),
            
            "Logistics Provider": (() => {
                if (data.logistics_order?.seller_service?.user?.user_business?.business_name) {
                    return data.logistics_order.seller_service.user.user_business.business_name;
                }
                
                if (data.order_id && data.logistics_vendor_id > 0 && data.logistics_order_id>0) {
                    const allOrders = orders;
                    const relatedOrder = allOrders.find(
                        o => o.order_id === data.order_id && 
                            o.logistics_order?.seller_service?.user?.user_business?.business_name
                    );
                    
                    if (relatedOrder) {
                        return relatedOrder.logistics_order.seller_service.user.user_business.business_name;
                    }
                }
                
                return "NA";
            })(),
            "Order Price": data.order_price || 0,
            "Tax Rate":  Number(data.tax_percent || 0),
        "Taxable Amount": data.taxable_amount || 0,
        "Igst Rate":  data.igst_percent || 0,
        "Igst Amount":  data.igst || 0,
        "Sgst Rate":  data.sgst_percent || 0,
        "Sgst Amount":  data.sgst || 0,
        "Cgst Rate":  data.cgst_percent || 0,
        "Cgst Amount": data.cgst || 0,
        "Unit Price": data.product_item?.price || data.seller_service?.price || data.offline_sale_product_datum?.price || 0,
        "Order Quantity": data.order_quantity || 0,
        "Order Status": data.order_status || "",
        "Order Date": data.order?.created_at,
        "Return CGST Amount": data.rcgst || 0,
        "Return CGST Rate": data.rcgst_percent || 0,
        "Return GST Rate": data.rgst_rate || 0,
        "Return IGST Amount": data.rigst || 0,
        "Return IGST Rate": data.rigst_percent || 0,
        "Return IRN": data.rirn || "",
        "Return IRN Date": data.rirn_date || "",
        "Return SGST Amount": data.rsgst || 0,
        "Return SGST Rate": data.rsgst_percent || 0,
        "Return Taxable Value": data.rtaxable_value || 0,
        "Return UTGST Amount": data.rutgst || 0,
        "Return UTGST Rate": data.rutgst_percent || 0,
        "Credit Note Date": data.rnote_date || "",
        "Credit Note No": data.rnote_no || "",
        "Credit Note Supply Type": data.rnote_supply_type || "",
        "Credit Note Type": data.rnote_type || "",
        "Credit Note Value": parseValue(data.rnote_value || 0, 'float'),
        "Cancel Note No": data.cancel_note_no || "",
        "Cancel Note Type": data.cancel_note_type || "",
        "Cancel Note Date": data.cancel_note_date || "",
        "Cancel Note Value": data.cancel_note_value || 0,
        "Cancel GST Rate": data.cancel_gst_rate || 0,
        "Cancel Taxable Value": data.cancel_taxable_value || 0,
        "Cancel IGST": data.cancel_igst || 0,
        "Cancel IGST %": data.cancel_igst_percent || 0,
        "Cancel CGST": data.cancel_cgst || 0,
        "Cancel CGST %": data.cancel_cgst_percent || 0,
        "Cancel SGST": data.cancel_sgst || 0,
        "Cancel SGST %": data.cancel_sgst_percent || 0,
        "Cancel UTGST": data.cancel_utgst || 0,
        "Cancel UTGST %": data.cancel_utgst_percent || 0,        
        "Cancel IRN": data.cancel_irn || 0,
    }));
    
    const handleExportCSV = () => {
        exportToCSV(data, 'orders.csv');
    }
    
    const handleExportExcel = () => {
        exportToExcel(data, 'orders.xlsx');
    }

    const handleExportPDF = () => {
        exportToPDF(data, 'orders.pdf');
    }

    const columns = [
  { accessor: 'order.order_id', header: 'Order ID',
    render: (row) =>
      row.order.order_id
   },
  {
    accessor: 'orderType',
    header: 'Order Type',
    render: (row) =>
      row.product_item ? "Online Product Sale" :
      row.seller_service ? "Online Service Sale" :
      "Offline Product Sale"
  },
  { accessor: 'order.created_at', header: 'Order Date',
    render: (row) =>
      row.order.created_at
   },
  {
    accessor: 'productName',
    header: 'Product Name',
    render: (row) =>
      row.product_item ? row.product_item.product.name :
      row.seller_service ? row.seller_service.service_name :
      row.offline_sale_product_datum ? row.offline_sale_product_datum.product_description :
      "NA"
  },
  {
    accessor: 'productDescription',
    header: 'Product Description',
    render: (row) =>
      row.product_item ? row.product_item.product.description :
      row.seller_service ? row.seller_service.service_description :
      row.offline_sale_product_datum ? row.offline_sale_product_datum.product_description :
      "NA"
  },
  {
    accessor: 'userInvoiceNo',
    header: 'User Invoice No',
    render: (row) => {
      const invoice = row.order?.invoices?.find(inv => inv.invoice_type === 'product');
      return invoice?.invoice_no || "NA";
    }
  },
  {
    accessor: 'sellerInvoiceNo',
    header: 'Seller Invoice No',
    render: (row) => {
      const invoice = row.order?.invoices?.find(inv => inv.invoice_type === 'seller_product');
      return invoice?.invoice_no || "NA";
    }
  },
  { accessor: 'rcgst', header: 'Return CGST Amount', render: row => parseValue(row.rcgst || 0, 'float') },
  { accessor: 'rcgst_percent', header: 'Return CGST Rate' },
  { accessor: 'rgst_rate', header: 'Return GST Rate', render: row => parseValue(row.rgst_rate || 0, 'float') },
  { accessor: 'rigst', header: 'Return IGST Amount', render: row => parseValue(row.rigst || 0, 'float') },
  { accessor: 'rigst_percent', header: 'Return IGST Rate' },
  { accessor: 'rirn', header: 'Return IRN' },
  { accessor: 'rirn_date', header: 'Return IRN Date' },
  { accessor: 'rnote_date', header: 'Credit Note Date' },
  { accessor: 'rnote_no', header: 'Credit Note No' },
  { accessor: 'rnote_supply_type', header: 'Credit Note Supply Type' },
  { accessor: 'rnote_type', header: 'Credit Note Type' },
  { accessor: 'rnote_value', header: 'Credit Note Value', render: row => parseValue(row.rnote_value || 0, 'float') },
  { accessor: 'rsgst', header: 'Return SGST Amount', render: row => parseValue(row.rsgst || 0, 'float') },
  { accessor: 'rsgst_percent', header: 'Return SGST Rate' },
  { accessor: 'rtaxable_value', header: 'Return Taxable Value', render: row => parseValue(row.rtaxable_value || 0, 'float') },
  { accessor: 'rutgst', header: 'Return UTGST Amount', render: row => parseValue(row.rutgst || 0, 'float') },
  { accessor: 'rutgst_percent', header: 'Return UTGST Rate' },
  {
    accessor: 'LogisticsInvoiceNo',
    header: 'Logistics Invoice No',
    render: (row) => {
      const invoice = row.logistics_order?.all_logistics_invoice?.find(inv => inv.invoice_type === 'logistics');
      return invoice?.invoice_no || "NA";
    }
  },
  {
    accessor: 'LogisticsPrice',
    header: 'Logistics Price',
    render: (row) => {
      const invoice = row.logistics_order?.all_logistics_invoice?.find(inv => inv.invoice_type === 'logistics');
      if (invoice?.price) {
        const itemCount = row.logistics_order?.order_item_id?.split(',').length || 1;
        return (parseValue(invoice.price, 'float') / itemCount).toFixed(2);
      }
      return "NA";
    }
  },
  {
    accessor: 'LogisticsProvider',
    header: 'Logistics Provider',
    render: (row) => {
      if (row.logistics_order?.seller_service?.user?.user_business?.business_name) {
        return row.logistics_order.seller_service.user.user_business.business_name;
      }
      if (row.order_id && row.logistics_vendor_id > 0) {
        const allRows = row.api?.getModel?.()?.rowsToDisplay || [];
        const relatedRow = allRows.find(
          r =>
            r.data?.logistics_order_id === row.logistics_order_id &&
            r.data?.logistics_order?.seller_service?.user?.user_business?.business_name
        );
        if (relatedRow) {
          return relatedRow.data.logistics_order.seller_service.user.user_business.business_name;
        }
      }
      return "NA";
    }
  },
  {
    accessor: 'order_price',
    header: 'Order Price',
    render: row => parseValue(row.order_price || 0, 'float')
  },
  {
    accessor: 'tax_percent',
    header: 'Tax Rate',
    render: row => row.tax_percent || 0
  },
  {
    accessor: 'taxable_amount',
    header: 'Taxable Amount',
    render: row => parseValue(row.taxable_amount || 0, 'float')
  },
  { accessor: 'igst_percent', header: 'IGST Rate' },
  { accessor: 'igst', header: 'IGST Amount' },
  {
    accessor: 'sgst_percent',
    header: 'SGST/UTGST Rate',
    render: row => row.sgst_percent || 0
  },
  {
    accessor: 'sgst',
    header: 'SGST/UTGST Amount',
    render: row => parseValue(row.sgst || 0, 'float')
  },
  {
    accessor: 'cgst_percent',
    header: 'CGST Rate',
    render: row => parseValue(row.cgst_percent || 0, 'float')
  },
  {
    accessor: 'cgst',
    header: 'CGST Amount',
    render: row => parseValue(row.cgst || 0, 'float')
  },
  {
    accessor: 'unit_price',
    header: 'Unit Price',
    render: row =>
      parseValue(
        row.product_item?.price ||
        row.seller_service?.price ||
        row.offline_sale_product_datum?.price ||
        0,
        'float'
      )
  },
  { accessor: 'order_quantity', header: 'Order Quantity' },
  { accessor: 'order_status', header: 'Order Status' },
  {
    header: 'View Order Images',
    render: (row) => (
      <button type='button' className='form-control btn btn-info' onClick={() => showOrderImages(row.id)}>View Order Images</button>
    )
  },
  {
    header: 'View Order Trackings',
    render: (row) => (
      <button type='button' className='form-control btn btn-info' onClick={() => showOrderTrackings(row.id)}>View Order Trackings</button>
    )
  },
  { accessor: 'return_reason', header: 'Return Reason' },
  { accessor: 'replace_reason', header: 'Replace Reason' },
  { accessor: 'cancel_reason', header: 'Cancel Reason' },
  { accessor: 'order_completed_on', header: 'Order Completed On' },
  { accessor: 'order_cancelled_on', header: 'Order Cancelled On' },
  {
    accessor: 'payment_id',
    header: 'Payment ID',
    render: row => row.order?.payment_detail?.razorpay_payment_id || ''
  },
  {
    accessor: 'payment_status',
    header: 'Payment Status',
    render: row => (row.order?.payment_detail || row.wallet_amount ? "Success" : "Failed")
  },
  { accessor: 'cancel_note_no', header: 'Cancel Note No' },
  { accessor: 'cancel_note_type', header: 'Cancel Note Type' },
  { accessor: 'cancel_note_date', header: 'Cancel Note Date' },
  { accessor: 'cancel_note_value', header: 'Cancel Note Value' },
  { accessor: 'cancel_gst_rate', header: 'Cancel GST Rate' },
  { accessor: 'cancel_taxable_value', header: 'Cancel Taxable Value' },
  { accessor: 'cancel_igst', header: 'Cancel IGST' },
  { accessor: 'cancel_igst_percent', header: 'Cancel IGST %' },
  { accessor: 'cancel_cgst', header: 'Cancel CGST' },
  { accessor: 'cancel_cgst_percent', header: 'Cancel CGST %' },
  { accessor: 'cancel_sgst', header: 'Cancel SGST' },
  { accessor: 'cancel_sgst_percent', header: 'Cancel SGST %' },
  { accessor: 'cancel_utgst', header: 'Cancel UTGST' },
  { accessor: 'cancel_utgst_percent', header: 'Cancel UTGST %' },
  { accessor: 'cancel_irn', header: 'Cancel IRN' },
  {
    header: 'Delivery Person',
    render: (row) => {
      const user = deliveryUsers.find(u => u.id === row.deliver_id);
      return row.deliver_id ? (user ? `${user.first_name} ${user.last_name}` : "NA") : "NA";
    }
  },
  {
    header: 'Return Delivery Person',
    render: (row) => {
      const user = deliveryUsers.find(u => u.id === row.deliver_id);
      return row.return_deliver_id ? (user ? `${user.first_name} ${user.last_name}` : "NA") : "NA";
    }
  },
  {
    header: 'Replace Delivery Person',
    render: (row) => {
      const user = deliveryUsers.find(u => u.id === row.deliver_id);
      return row.replace_deliver_id ? (user ? `${user.first_name} ${user.last_name}` : "NA") : "NA";
    }
  },
  {
    header: 'Return Logistics Vendor',
    render: (row) => {
      if (row.product_id && row.product_item?.self_deliver === 0) {
        if (row.return_logistics_seller) {
          const f = row.return_logistics_seller.first_name || '';
          const l = row.return_logistics_seller.last_name || '';
          return f + (f && l ? ' ' : '') + l || 'NA';
        }
        return 'NA';
      }
      return 'NA';
    }
  },
  {
    header: 'Select Replace Logistics Vendor',
    render: (row) => {
      if (row.product_id && row.product_item?.self_deliver === 0) {
        if (row.replace_logistics_vendor && row.replace_logistics_seller) {
          const f = row.replace_logistics_seller.first_name || '';
          const l = row.replace_logistics_seller.last_name || '';
          return f + (f && l ? ' ' : '') + l || 'NA';
        }
        return 'NA';
      }
      return 'NA';
    }
  },
  {
    header: 'Download Manifest',
    render: (row) =>
      row.third_party_logistics_partner_name === "shiprocket" ? (
        <button
          className="btn btn-outline-success btn-sm usercardbtn1"
          onClick={() => downloadManifestOrLabel(row.manifest_url || row.replace_manifest_url || null)}
        >
          Download
        </button>
      ) : "NA"
  },
  {
    header: 'Download Label',
    render: (row) =>
      row.third_party_logistics_partner_name === "shiprocket" && row.label_url ? (
        <button
          className="btn btn-outline-success btn-sm usercardbtn1"
          onClick={() => downloadManifestOrLabel(row.label_url)}
        >
          Download
        </button>
      ) : row.third_party_logistics_partner_name === "ecomexpress" && row.awb ? (
        <button
          className="btn btn-outline-success btn-sm usercardbtn1"
          onClick={() => downloadManifestOrLabel(row.awb, true, row.id, 'label_url')}
        >
          Download
        </button>
      ) : "NA"
  },
  {
    header: 'Download Replace Label',
    render: (row) =>
      row.third_party_logistics_partner_name === "shiprocket" && row.replace_label_url ? (
        <button
          className="btn btn-outline-success btn-sm usercardbtn1"
          onClick={() => downloadManifestOrLabel(row.replace_label_url)}
        >
          Download
        </button>
      ) : row.third_party_logistics_partner_name === "ecomexpress" && row.replace_awb ? (
        <button
          className="btn btn-outline-success btn-sm usercardbtn1"
          onClick={() => downloadManifestOrLabel(row.replace_awb, true, row.id, 'replace_label_url')}
        >
          Download
        </button>
      ) : "NA"
  },
  {
    header: 'Generate Invoice',
    render: (row) => (
      <button
        className="btn btn-outline-success btn-sm usercardbtn1"
        onClick={() => generateInvoice(row.seller_id, row.order?.id, ['seller_product'])}
      >
        Invoice Generate
      </button>
    )
  },
  {
    header: 'Generate Return Invoice',
    render: (row) =>
      row.order_returned_on ? (
        <button
          className="btn btn-outline-success btn-sm"
          onClick={() =>
            generateReturnReplaceCancelInvoice(
              row.id,
              [row.seller_id, row.order.user_id],
              ['return_order', 'return_order_logistics'],
              'Return'
            )
          }
        >
          Return Invoice Generate
        </button>
      ) : null
  },
  {
    header: 'Generate Replace Invoice',
    render: (row) =>
      row.order_replaced_on ? (
        <button
          className="btn btn-outline-success btn-sm"
          onClick={() =>
            generateReturnReplaceCancelInvoice(
              row.id,
              [row.seller_id],
              ['replace_order_logistics', 'return_order_logistics'],
              'Replace'
            )
          }
        >
          Replace Invoice Generate
        </button>
      ) : null
  },
  {
    header: 'Generate Cancel Invoice',
    render: (row) =>
      row.order_cancelled_on ? (
        <button
          className="btn btn-outline-success btn-sm"
          onClick={() =>
            generateReturnReplaceCancelInvoice(
              row.id,
              [row.seller_id],
              ['cancel_order_seller'],
              'Cancel'
            )
          }
        >
          Cancel Invoice Generate
        </button>
      ) : null
  },
  {
    header: 'Commission Invoice',
    render: (row) =>
      row.comm_invoice_no ? (
        <button
          className="btn btn-outline-success btn-sm"
          onClick={() => generateCommissionInvoice(row.id)}
        >
          Generate Invoice
        </button>
      ) : 'Invoice Yet To Be Generated'
  },
  {
    accessor: 'round_off',
    header: 'Round Off',
  }
];

    return (
        <>
            <div className="row">
                <div className='col-md-6'>
                    <h3>Orders</h3>
                </div>
                <div className='col-md-6'>
                    <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                    <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                    <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
                </div>
            </div>
                    <Form className='row ml-2'>
                        <FormGroup className='col-md-4 row'>
                            <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                            <input type='date' defaultValue={location.state.startDate.length > 0 ? location.state.startDate : moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getOrders()} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
                        </FormGroup>
                        <FormGroup className='col-md-4 row'>
                            <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
                            <input type='date' defaultValue={location.state.endDate.length > 0 ? location.state.endDate : moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getOrders()} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
                        </FormGroup>
                    </Form>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
                        <Table
                            columns={columns}
                            data={orders}
                            totalRecords={totalRecords}
                            pageSize={10}
                            onPageChange = {getOrders}
                        />
                    </div>
                </div>
            </div>

            <Modal isOpen={showOrderImagesModal} toggle={() => setShowOrderImagesModal(!showOrderImagesModal)} size="lg">
                <ModalHeader toggle={() => setShowOrderImagesModal(!showOrderImagesModal)}>Order Images</ModalHeader>
                <ModalBody>
                    {
                        orderImagesData && orderImagesData.length > 0 ?
                        <table>
                            <thead>
                                <th>Photo</th>
                                <th>Uploaded By</th>
                                <th>Type</th>
                                <th>Upload Date Time</th>
                            </thead>
                            <tbody>
                            {
                                orderImagesData.map((imageData) => {
                                    return (
                                    <>
                                        <tr>
                                            <td><img src={envConfig.api_url + imageData.photo} style={{ width: '100px', height: '100px', objectFit: 'cover' }} /></td>
                                            <td>{imageData.uploaded_via}</td>
                                            <td>{imageData.type}</td>
                                            <td>{imageData.created_at}</td>
                                        </tr>
                                    </>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        :
                        <h4>No Order Images</h4>
                    }
                </ModalBody>
            </Modal>

            <Modal isOpen={orderTrackings} toggle={() => showOrderTrackings(0)} size="lg">
                <ModalHeader toggle={() => showOrderTrackings(0)}>Order Trackings</ModalHeader>
                <ModalBody>
                    {
                        orderTrackingData && orderTrackingData.length > 0 ?
                        <table>
                            <thead>
                            <tr>
                                <th>Status</th>
                                <th>Remarks</th>
                                <th>Time</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                orderTrackingData.map((tracking) => {
                                    return (
                                    <>
                                        <tr>
                                            <td>{tracking?.status.replaceAll('_', ' ') || ''}</td>
                                            <td>{tracking?.remarks.replaceAll('_', ' ') || ''}</td>
                                            <td>{tracking?.created_at.replaceAll('_', ' ') || ''}</td>
                                        </tr>
                                    </>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        :
                        <h4>No Trackings Found</h4>
                    }
                </ModalBody>
            </Modal>

            <Modal isOpen={showLogisticsVendor.show} toggle={() => setShowLogisticsVendor({show: !showLogisticsVendor.show, orderItemId: 0, type: null, orderId: 0, sellerAddressId: 0, sellerId: 0, self_deliver: 0, order_status: null})} size="lg">
                <ModalHeader toggle={() => setShowLogisticsVendor({show: !showLogisticsVendor.show, orderItemId: 0, type: null, orderId: 0, sellerAddressId: 0, sellerId: 0, self_deliver: 0, order_status: null})}>Logistics Vendors</ModalHeader>
                <ModalBody>
                    <div 
                        className="col-md-12" 
                        style={{ 
                            height: '250px',            
                            overflowY: 'scroll',        
                            border: '1px solid #ddd',   
                            marginBottom: '15px'
                        }}
                    >
                        {(supplyVendors.vendors && supplyVendors.vendors.length > 0) ? supplyVendors.vendors.map(vendor => (
                            <div className="row">
                                <div className="col-md-12">
                                    <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer',padding: '8px'}}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="logistics_vendor_id"
                                            onClick={() => updateReturnReplaceLogisticsVendor(1, vendor, -1)}
                                        />
                                        <span style={{ marginLeft: '8px' }}>Rs. {vendor.seller_service.price}</span>&nbsp;
                                        <span>
                                            Between {vendor.seller_service.min_delivery_time} and {vendor.seller_service.max_delivery_time} ({vendor.seller_service.logistics_delivery_type})
                                        </span>
                                    </label>
                                    <br />
                                </div>
                            </div>
                        )) : ""}
                        
                        {/* Render third-party vendors if they exist */}
                        {(supplyVendors.thirdPartyVendors && (supplyVendors.thirdPartyVendors.shiprocket?.data || supplyVendors.thirdPartyVendors.ecomexpress?.data)) && (
                            <>
                                {/* Render Ecomexpress vendors */}
                                {supplyVendors.thirdPartyVendors.ecomexpress?.data?.length > 0 && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '8px' }}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="logistics_vendor_id"
                                                    onClick={() => updateReturnReplaceLogisticsVendor(1, supplyVendors.thirdPartyVendors.ecomexpress, -2)}
                                                />
                                                <span style={{ marginLeft: '8px' }}>Rs. {supplyVendors.thirdPartyVendors.ecomexpress.total_price} (Ecom Express)</span>&nbsp;
                                            </label>
                                            <br />
                                        </div>
                                    </div>
                                )}

                                {/* Render Shiprocket vendors */}
                                {supplyVendors.thirdPartyVendors.shiprocket?.data?.length > 0 && supplyVendors.thirdPartyVendors.shiprocket.total_price.map((price, index) => (
                                    <div className="row" key={index}>
                                        <div className="col-md-12">
                                            <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '8px' }}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="logistics_vendor_id"
                                                    onClick={() => updateReturnReplaceLogisticsVendor(1, supplyVendors.thirdPartyVendors.shiprocket, index)}
                                                />
                                                <span style={{ marginLeft: '8px' }}>Rs. {price}</span>&nbsp;
                                            </label>
                                            <br />
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}